// extracted by mini-css-extract-plugin
export default {"loaderSection":"loaderWhite_loaderSection__p9MtB","loaderSecitionh1":"loaderWhite_loaderSecitionh1__kX0ko","lds_ring":"loaderWhite_lds_ring__+3Ekj"};